import http from '@/requests/http'

class Inquiry {
  static all (params) {
    return http.post('configuration/consultation/inquiry/index', params)
  }
  static async view (params) {
    return http.post('configuration/consultation/inquiry/view', params)
  }
  static async update (data) {
    return http.post('configuration/consultation/inquiry/update', data)
  }
  static async save (data) {
    return http.post('configuration/consultation/inquiry/store', data)
  }
  static async delete (id) {
    return http.post(`configuration/consultation/inquiry/delete/${id}`)
  }
}

export default Inquiry
